import md5 from 'blueimp-md5'
import PinYin from './pinyin'
String.prototype.gllength = function() {
    let len = 0
    for (let i = 0; i < this.length; i++) {
        if (this.charCodeAt(i) > 127 || this.charCodeAt(i) == 94) {
            len += 2
        } else {
            len++
        }
    }
    return len
}

function dateFormat(date, format = 'yyyy-MM-dd hh:mm:ss') {
    if (!date) return ''
    date = new Date(date)
    let map = {
        M: date.getMonth() + 1, //月份
        d: date.getDate(), //日
        h: date.getHours(), //小时
        m: date.getMinutes(), //分
        s: date.getSeconds(), //秒
        q: Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
    }
    format = format.replace(/([yMdhmsqS])+/g, (all, t) => {
        let v = map[t]
        if (v !== undefined) {
            if (all.length > 1) {
                v = '0' + v
                v = v.substr(v.length - 2)
            }
            return v
        } else if (t === 'y') {
            return (date.getFullYear() + '').substr(4 - all.length)
        }
        return all
    })
    return format
}

function setTimeoutToPromise(durtion) {
    return new Promise(resolve => setTimeout(resolve, durtion))
}
/**
 * 通过成员的属性值进行递归排序
 * @param {array} array 需要排序的数据
 * @param {string} sortAttr 排序依据的属性
 * @param {string} deepAttr 递归的属性
 */
function sortDeepByAttr(array, sortAttr, deepAttr) {
    array.sort((a, b) => {
        return a.meta[sortAttr] - b.meta[sortAttr]
    })
    return array.map(item => {
        if (item[deepAttr] && item[deepAttr].length > 0) {
            item[deepAttr] = sortByIndex(item[deepAttr], sortAttr, deepAttr)
        }
        return item
    })
}
/**
 * 生成全局UUID
 */
function getUUID() {
    var d = new Date().getTime()
    if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now()
    }
    var uuid = 'xxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
    return uuid
}

function ConvertPinyin(l1) {
    //汉字库
    var l2 = l1.length
    var I1 = ''
    var reg = new RegExp('[a-zA-Z0-9- ]')
    for (var i = 0; i < l2; i++) {
        var val = l1.substr(i, 1)
        var name
        for (var temp in PinYin) {
            if (PinYin[temp].indexOf(val) != -1) {
                if (temp.length > 0) {
                    var first = temp.substr(0, 1).toLowerCase()
                    name = first
                }
                break
            }
        }
        if (reg.test(val)) {
            I1 += val
        } else if (name !== false) {
            I1 += name
        }
    }
    I1 = I1.replace(/ /g, '-')
    while (I1.indexOf('--') > 0) {
        I1 = I1.replace('--', '-')
    }
    return I1
}
/**
 * 含有字符TZ  字符日期字符串 转化为不含TZ 日期的字符串
 * 支持 '2019-07-25T16:00:00.000Z‘  '2019-07-25T16:00:00.000‘ '2019-07-26:00:00.000Z‘
 * 支持 1530540726443 类型 转换为 日期字符串
 * @param inputTime
 * @returns {string}
 */
function timeToLocal(inputTime) {
    if (!inputTime && typeof inputTime !== 'number') {
        return ''
    }
    var localTime = ''
    inputTime = new Date(inputTime).getTime()
    const offset = new Date().getTimezoneOffset()
    localTime = new Date(inputTime - offset * 60000).toISOString()
    localTime = localTime.substr(0, localTime.lastIndexOf('.'))
    localTime = localTime.replace('T', ' ')
    return localTime
}
// 如果时间是个位数，就补0
function addZero(obj) {
    return obj < 10 ? '0' + obj : obj
}
/**
 * 判断是否为空
 * @param value
 * @returns {boolean}
 */
function isNull(value) {
    if (typeof value != 'number') {
        if (!value ||
            value === undefined ||
            value === null ||
            value === '' ||
            value === ''
        ) {
            return true
        }
    }
    return false
}
/**
 * 判断不是空
 * @param value
 * @returns {boolean}
 */
function isNotNull(value) {
    if (
        value &&
        value !== undefined &&
        value !== null &&
        value !== '' &&
        value !== ''
    ) {
        return true
    }
    return false
}
/**
 * double 自动补0
 * @param num 传入的数值
 * @param decimals 小数位数
 * @returns {*}
 * 例 floatJoinZero(2.11,4)   return 2.1100
 */
function floatJoinZero(num, decimals) {
    var xsdArry = num.toString().split('.')
    let zeroStr = '0'
    if (xsdArry.length == 1) {
        for (let i = 0; i < decimals - 1; i++) {
            zeroStr = zeroStr + '0'
        }
        num = num + '.' + zeroStr
    }
    if (xsdArry.length > 1) {
        if (xsdArry[1].length < decimals) {
            for (let i = 0; i < decimals - xsdArry[1].length - 1; i++) {
                zeroStr = zeroStr + '0'
            }
            num = num + zeroStr
        }
    }
    return num
}

function validategllength1to20(rule, value, callback) {
    if (value != null && value != '') {
        if (value.trim().gllength() > 20) {
            callback(new Error('请输入1-20个字符'))
        }
    }
    callback()
}

function validategllength1to60(rule, value, callback) {
    if (value != null && value != '') {
        if (value.trim().gllength() > 60) {
            callback(new Error('请输入1-60个字符'))
        }
    }
    callback()
}

function validategllength2And10(rule, value, callback) {
    if (value == undefined) {
        callback()
    }
    if (value.trim().gllength() > 30 || value.trim().gllength() < 1) {
        callback(new Error('请输入1-30个字符(1汉字=2字母=2字符)'))
    } else {
        callback()
    }
}

function validategllength2And100(rule, value, callback) {
  if (value.trim().gllength() > 100 || value.trim().gllength() < 2) {
    callback(new Error('请输入2-100个字符(1汉字=2字母=2字符)'));
  } else {
    callback();
  }
}

function validategllength(rule, value, callback) {
    if (value != null && value != '') {
        if (value.trim().gllength() > 100) {
            callback(new Error('请输入1-50个汉字'))
        }
    }
    callback()
}

function contactNamelength(rule, value, callback) {
    if (value != null && value != '') {
        if (value.trim().gllength() > 60) {
            callback(new Error('请输入1-60个字符'))
        }
    }
    callback()
}

function eventAddresslength(rule, value, callback) {
    if (value != null && value != '') {
        if (value.trim().gllength() > 80) {
            callback(new Error('请输入1-80个字符'))
        }
    }
    callback()
}

function eventDescriptionlength(rule, value, callback) {
    if (value != null && value != '') {
        if (value.trim().gllength() > 200) {
            callback(new Error('请输入1-200个字符'))
        }
    }
    callback()
}
//动态长度时规则校验
function dynicVallength(rule, value, callback) {
    if (value != null && value != '') {
        if (value.trim().gllength() > rule.maxLength) {
            callback(
                new Error('请输入1-' + rule.maxLength + '个字符(1汉字=2字母=2字符)')
            )
        }
    }
    callback()
}
//动态长度时规则校验(最大最小长度同时)
function dynicMaxAndMinLength(rule, value, callback) {
    if (value != null && value != '') {
        if (value.trim().gllength() > rule.maxLength) {
            callback(
                new Error(
                    '请输入' +
                    rule.minLength +
                    '-' +
                    rule.maxLength +
                    '个字符(1汉字=2字母=2字符)'
                )
            )
        }
        if (value.trim().gllength() < rule.minLength) {
            callback(
                new Error('请至少输入' + rule.minLength + '个字符(1汉字=2字母=2字符)')
            )
        }
    }
    callback()
}
//动态验证实数 最大值
function dynicMaxDouble(rule, value, callback) {
    if (value != null && value != '') {
        let maxInt = addEndZero(1, rule.maxLength) - 1
        let maxDou = addEndZero(1, rule.fieldDecimals) - 1
        let max = parseFloat(maxInt + '.' + maxDou)
        if (value > max) {
            callback(new Error('不能大于 ' + max))
        }
    }
    callback()
}
//动态验证整数 最大值
function dynicMaxInt(rule, value, callback) {
    if (value != undefined && value != null && value != '') {
        let maxInt = addEndZero(1, rule.maxLength) - 1
        if (value > maxInt) {
            callback(new Error('不能大于 ' + maxInt))
        }
    }
    callback()
}
/**
 * 传入num 前自动补充 0 例如  addFirstZero(32,4)   0032
 * @param num
 * @param len
 * @returns {string}
 */
function addFirstZero(num, len) { return `${num}`.padStart(len, '0') }
/**
 * 传入num 后自动补充 0 例如  addEndZero(32,4)   320000
 * @param num
 * @param length
 * @returns {number}
 */
function addEndZero(num, length) {
    let str = '0'
    for (let i = 0; i < length - 1; i++) {
        str = str + '0'
    }
    return Number(num + str)
}

function eventfDescriptionlength(rule, value, callback) {
    if (value != null && value != '') {
        if (value.trim().gllength() > rule.maxLength) {
            callback(
                new Error(
                    `超出最大长度${rule.maxLength}个字符的限制(1汉字=2字母=2字符)`
                )
            )
        }
    }
    callback()
}
/**
 * 动态长度时规则校验 最小长度 不能小于最小长度
 *小于最小长度 返回false  大于最小长度 返回 true
 * @param value
 * @param minLength 最小长度
 * @returns {boolean}
 */
function dynicValMinength(value, minLength) {
    if (value === undefined || value.trim().gllength() < minLength) {
        return false
    }
    return true
}
/**
 * 动态长度时规则校验 最大长度 不能大于最大长度
 *大于最大长度 返回false
 * @param value
 * @param maxLength 最大长度
 * @returns {boolean}
 */
function dynicValMaxLength(value, maxLength) {
    if (value === undefined) {
        return true
    }
    if (value.trim().gllength() > maxLength) {
        return false
    }
    return true
}
/**
 * 脱敏
 */
function filterSens(str) {
    // userType：1运营     2租户     4客服   5质检  6业务  7其他 
    let userType = JSON.parse(window.localStorage.user).info.userType;
    if (userType !== "2" && str) {
        if(window.localStorage.desensitization === '1') {
          return (str.substring(0, 3) + '****' + str.substring(3 + 4))
        }else if(window.localStorage.desensitization === '2') {
          let len = str.length
          let countStr = ''
          for(let i = 0; i < len; i ++) {
            countStr += '*'
          }
          return countStr
        }else if(window.localStorage.desensitization === '0') {
          return str
        }
    } else {
        return str
    }
}
// 地址分割
const getIndex = (str,strpram,index) => {
  var strValue=str;
  var strValue1="";
  var value=0;
  for(var i =0;i < index;i++){
  strValue1 = strValue.substring(0,strValue.indexOf(strpram));
  strValue = strValue.substring(strValue1.length+1);
  value += (strValue1.length+1);
  }
  return value;
}
const filterAreaValue = (str,num) => {
  if(!str){
    if(num==0){
      return []
    }else{
      return ""
    }
  }else{
    let arr = str.split("/")
    if(num==0){
      return [arr[0],arr[1],arr[2]]
    }else{
      let _i = getIndex(str,"/",3)
      return str.substring(_i,str.length)
    }
  }
}
const regs = (type,noGlobal) => {
  let re = {
    phone: '',
    idCard: '(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)'
  }
  if(noGlobal){
    return new RegExp(re[type])
  }
  return new RegExp(re[type],g)
}
export {
    dateFormat,
    setTimeoutToPromise,
    sortDeepByAttr,
    getUUID,
    md5,
    ConvertPinyin,
    timeToLocal,
    addZero,
    isNull,
    isNotNull,
    floatJoinZero,
    validategllength1to20,
    validategllength1to60,
    validategllength2And10,
    validategllength2And100,
    validategllength,
    contactNamelength,
    eventAddresslength,
    eventDescriptionlength,
    dynicVallength,
    dynicMaxAndMinLength,
    dynicMaxDouble,
    dynicMaxInt,
    addFirstZero,
    addEndZero,
    eventfDescriptionlength,
    dynicValMinength,
    dynicValMaxLength,
    filterSens,
    filterAreaValue,
    regs
}